import * as yup from 'yup';

export const createExtensionSchema = (initialEmailOptions: { value: string }[] = []) =>
  yup.object().shape({
    agentName: yup.string().required('Agent name is required'),
    agencyContactPerson: yup.string().required('Agency contact person is required'),
    agencyEmail: yup
      .string()
      .required('Agency email is required')
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        'Please enter a valid email address'
      ),
    clinicName: yup.string().required('End User (Clinic) Name is required'),
    userContactName: yup.string().optional(),
    userContactEmail: yup
      .string()
      .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, {
        message: 'Please enter a valid email address',
        excludeEmptyString: true,
      })
      .test(
        'required-when-selected',
        'This email is required because it is selected as notification email',
        function (value) {
          const { notificationEmail, agencyEmail } = this.parent;
          if (notificationEmail && notificationEmail !== agencyEmail && !value) {
            return true;
          }
          return true;
        }
      )
      .optional(),
    notificationEmail: yup
      .string()
      .required('Notification email is required')
      .test(
        'is-valid-option',
        'Selected email does not exist. Please select another.',
        function (value) {
          const { agencyEmail, userContactEmail } = this.parent;
          if (!value) return true;
          if (value === agencyEmail) return true;
          if (userContactEmail && value === userContactEmail) return true;
          if (initialEmailOptions.some((opt) => opt.value === value)) return true;
          return false;
        }
      ),
  });

export const recorbAppDownloadSchema = yup.object().shape({
  serialNumber: yup.string().required('Serial number is required'),
  hardwareSignature: yup.string().required('Hardware Signature is required'),
  agentName: yup.string().optional(),
  agencyContactPerson: yup.string().optional(),
  agencyEmail: yup.string().optional(),
});